module.exports = __webpack_public_path__ + "img/modal-supplier-create.dab9b2cc.svg";